import "./Workcardstyle.css";
import React from 'react';
import my from "../assets/mine.jpg"
import { NavLink } from "react-router-dom";
import Projetworkcard from "./Projetworkcard";
import Projectcarddata from"./Projectcarddata";
const Projectwork = () => {
  return (
    <div className="work-container">
      <h1 className="role">Services</h1>
      <div className="description">

        {Projectcarddata.map((val,ind)=>{
            return(
                <Projetworkcard 
                key={ind}
                imgsrc={val.imgsrc}
                title={val.title}
                text={val.text}
                view={val.view}
                />
            )
        })}
      </div>
    </div>

      
    
  )
}

export default Projectwork;
